// extracted by mini-css-extract-plugin
export default {"container":"client_container__APoDO","ml100":"client_ml100__UdmE-"};